import React from "react";
import { CvsLogo } from "../../static/assets/icons/CvsLogo";
import { ICONS } from "../../static/assets/icons/icons";
import { TEXTS } from "../../static/texts";
import sectionStyles from "../sectionStyles.module.css";
import styles from "./style.module.css";

export const Contact = ({ pageTop, sectionRef }) => {
  const scrollToTop = () => {
    pageTop.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className={styles.wrapper} ref={sectionRef}>
      <div className={styles.contact}>
        <div className={styles.textContainer}>
          <h2 className={sectionStyles.largeText}>
            {TEXTS.CONTACT_SECTION_HEADER}
          </h2>
        </div>
        <div className={styles.iconsRow}>
          <a
            className={styles.iconContainer}
            href="https://www.instagram.com/concretvs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={ICONS.INSTAGRAM}
              alt="Instagram"
              className={styles.contactIcon}
            />
          </a>
          <a
            className={styles.iconContainer}
            href="https://api.whatsapp.com/send?phone=541149986500"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={ICONS.WHATSAPP}
              alt="Whatsapp"
              className={styles.contactIcon}
            />
          </a>
          <a
            className={styles.iconContainer}
            href="mailto:info@concretvs.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={ICONS.EMAIL} alt="Email" className={styles.contactIcon} />
          </a>
        </div>
      </div>
      <div className={styles.infoContainer}>
        <CvsLogo onClick={scrollToTop} className={styles.cvsLogo} />
        <p className={styles.footerInfo}>{TEXTS.FOOTER_INFO_ADDRESS}</p>
      </div>
    </div>
  );
};
